import React from 'react';
import './App.css';
import { ScopedCssBaseline, ThemeProvider, useMediaQuery, useTheme } from '@mui/material';
import { getTheme } from './theme';
import { NavigateFunction, Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from './components/layouts/auth-layout';
import MainLayout from './components/layouts/main-layout';
import FogotPassword from './containers/Auth/FogotPassword';
import SetPassword from './containers/Auth/SetPassword';
import ResetPassword from './containers/Auth/ResetPassword';
import { connect, useStore } from 'react-redux';
import { RootState } from './app/store';
import { authCheckState, authInit, authSetTokenTimer } from './store/actions';
import { useAppSelector } from './app/hooks';
import Dashboard from './containers/Dashboard/Dashboard';
import OfferDetail from './containers/Dashboard/OfferDetail';
import SnackBar from './components/snackbars/SnackBar';
import WhyCarwiser from "./containers/WhyCarwiser/WhyCarwiser";
import MyAccount from './containers/Account/MyAccount';
import ChangePassword from './containers/Account/ChangePassword';
import LoginOTP from './containers/Auth/LoginOTP';
import LoginMenu from './containers/Auth/LoginMenu';
import Otp from './containers/Auth/methods/Otp';
import MagicLink from './containers/Auth/methods/MagicLink';
import Password from './containers/Auth/methods/Password';
import AuthLayoutV2 from './components/layouts/auth-layout-v2';

class AppPropsDto {
  darkMode?: boolean;
  onInitApp: any;
  onTryAutoSignup: any;
  onSetTokenTimer: any;
}

function App(props: AppPropsDto) {
  const theme = React.useMemo(() => getTheme(props.darkMode), [props.darkMode]);
  const store = useStore();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
  const isAuthenticated = useAppSelector((state: RootState) => state.auth.isAuthenticated);
  const authToken = useAppSelector((state: RootState) => state.auth.token);

  React.useEffect(() => {
    const state = store.getState() as RootState;
    if (!state.auth.isInited) {
      props.onInitApp();
    }
    props.onTryAutoSignup(state, navigate);
  }, [props, navigate, store]); // state.auth.token
  const isAuthPath = window.location.pathname.indexOf('/auth') === 0 || 
    window.location.pathname.indexOf('/login') === 0 || 
    window.location.pathname.indexOf('/otp') === 0;

  React.useEffect(() => {
    if ((!isAuthenticated || !authToken) && !isAuthPath) {
        navigate('/login');
        return ;
    }
    props.onSetTokenTimer(authToken);
  }, [props, isAuthenticated, isAuthPath, authToken, navigate])
  const classes = ['main-wrapper'];
  isMobile && classes.push('mobile');
  if (isAuthenticated && !isAuthPath) {
    document.body.classList.remove('auth');
  } else {
    document.body.classList.add('auth');
    classes.push('auth');
  }

  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline enableColorScheme={true} className={classes.join(' ')}>
        <Routes>
          <Route path="/">
            <Route path="/dashboard" element={<MainLayout><Dashboard/></MainLayout>}/>
            <Route path="/offer" element={<MainLayout><OfferDetail/></MainLayout>}/>
            <Route path="/why-carwiser" element={<MainLayout><WhyCarwiser/></MainLayout>}/>
            <Route path="/account" element={<MainLayout><MyAccount/></MainLayout>}/>
            <Route path="/account/settings" element={<MainLayout><ChangePassword/></MainLayout>}/>
          </Route>
          <Route path="/login">
            <Route path="/login" element={<AuthLayoutV2><LoginMenu/></AuthLayoutV2>}/>
            <Route path="/login/otp" element={<AuthLayoutV2><Otp/></AuthLayoutV2>}/>
            <Route path="/login/ml" element={<AuthLayoutV2><MagicLink/></AuthLayoutV2>}/>
            <Route path="/login/pw" element={<AuthLayoutV2><Password/></AuthLayoutV2>}/>
          </Route>
          <Route path="/otp" element={<AuthLayoutV2><LoginOTP/></AuthLayoutV2>}/>
          <Route path="/auth">
            <Route path="set-password" element={<AuthLayout><SetPassword/></AuthLayout>}/>
            <Route path="reset-password" element={<AuthLayout><ResetPassword/></AuthLayout>}/>
            <Route path="forgot-password" element={<AuthLayoutV2><FogotPassword/></AuthLayoutV2>}/>
          </Route>
          {/* <Route path="/register" />  */}
        </Routes>
        <SnackBar/>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
      onTryAutoSignup: (state: RootState, navigate: NavigateFunction) => dispatch(
        authCheckState(state, navigate)),
      onInitApp: () => dispatch(authInit()),
      onSetTokenTimer: (token: any) => dispatch(authSetTokenTimer(token))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(App);
